/**
 * Content Domain — Seeds Barrel Export
 *
 * Re-exports all 10 module seed collections.
 * All modules are DDD-conformant (index.ts in content/seeds/{MODULE}/).
 * Fully migrated modules (all JSONs in DDD): TOPO, MET, SPR, STU, SWW, TAA, TIJD, GELD, REK, GET.
 *
 * Created in R29 (DDD Fase 3 — seeds barrel).
 * Migrated 15 maart 2026: all modules now route through content/seeds/.
 * REK module added 17 maart 2026 (Fase 0).
 * TGL Split activated 18 maart 2026 (Fase 0): seedTGL → seedTIJD + seedGELD.
 * See docs/guides/HUMAN_REVIEW_GUIDE.md for review process.
 */

export { default as seedSWW } from './SWW'
export { default as seedSPR } from './SPR'
export { default as seedGET } from './GET'
export { default as seedREK } from './REK'
export { default as seedMET } from './MET'
export { default as seedTIJD } from './TIJD'
export { default as seedGELD } from './GELD'
export { default as seedTOPO } from './TOPO'
export { default as seedTAA } from './TAA'
export { default as seedSTU } from './STU'
